import React from 'react';
import './Icon.scss';

export type IconProps = {
    icon: React.ReactNode;
    size: number;
} & {
    color?: 'white' | 'marine' | 'grey' | 'yellow' | 'green' | 'red' | 'blue';
    variant?: 'plain' | 'surrounded';
    bordered?: boolean;
    iconInsetSpacing?: number;
} & React.HTMLAttributes<HTMLDivElement>;

export const Icon: React.FC<IconProps> = ({
    icon,
    className,
    size,
    color = 'grey',
    variant = 'plain',
    bordered,
    iconInsetSpacing,
    ...props
}) => {
    const cn = `icon ${className ?? ''}`;

    return (
        <div
            className={cn}
            {...props}
            data-variant={variant}
            data-size={`${size}px`}
            data-color={color}
            data-bordered={bordered}
            style={
                {
                    '--icon-size': `${size}px`,
                    '--icon-inset-spacing': iconInsetSpacing ? `${iconInsetSpacing}px` : undefined
                } as React.CSSProperties
            }
        >
            {icon}
        </div>
    );
};
